import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class AddSerializer extends BaseSerializer {
  deserialize(raw, { bookmakerId }) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200;
    if (!success) {
      let message = serverRes.message || 'Impossible de vérifier votre compte. Veuillez réessayer.';
      // ancien message: (serverRes.message || 'Erreur lors de la récupération') + ` Code d'erreur: BOOKMAKER_ERR_${serverRes.statusCode || raw.status || '1000'}`
      if (serverRes.statusCode)
        message = `Votre id ${bookmakerId} n'est pas correcte, veuillez le revérifier`;
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message,
        data: null
      };
    }
    return {
      statuCode: 200,
      success: true,
      message: 'Got',
      data: {
        name: serverRes.data?.name,
        playerId: serverRes.data?.playerId,
        // currency: serverRes.data?.currency,
        // currencyId: serverRes.data?.currencyId
      }
    };
  }

  serialize() {}
}

export const serializer = new AddSerializer();
